import { faBuilding } from "@fortawesome/pro-duotone-svg-icons/faBuilding";

import { type Breadcrumb } from "@application/types/breadcrumb";

export const DASHBOARD_ORGANIZATIONS_LINK: Breadcrumb = {
  icon: faBuilding,
  name: "Organizations",
  to: "/dashboard/organizations",
};
